export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_fragment_3.960f93e1.jpg";